import { Card } from "@/components/ui/card";
import { Spinner } from "@/components/ui/spinner";
import { useAvailability } from "../api/get-availability";
import { AvailabilityUpdate } from "./weekly/availability-update";
import { ExceptionsUpdate } from "./exceptions/exceptions-update";

export const AvailabilityCard = () => {
    const { data: availability = [], isLoading: isAvailabilityLoading } =
        useAvailability();

    if (isAvailabilityLoading) {
        return (
            <div className="grid h-75 place-items-center">
                <Spinner size="lg" />
            </div>
        );
    }

    return (
        <div className="grid grid-cols-12 gap-4">
            <Card size="lg" className="col-span-full block md:col-span-6">
                <div className="col-span-6 flex h-full flex-col">
                    <AvailabilityUpdate availability={availability} />
                </div>
            </Card>

            <Card size="lg" className="col-span-full block md:col-span-6">
                <div className="col-span-6 flex h-full flex-col">
                    <ExceptionsUpdate availability={availability} />
                </div>
            </Card>
        </div>
    );
};
